export default __webpack_public_path__ + "static/media/1551.452f5468.png";